<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- <a-form-model-item label="企业品牌" prop="upperId">
        <a-select
          show-search
          v-model="form.upperId"
          placeholder="请选择"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item label="费用金额" prop="money">
        <a-input v-model="form.money" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="短信数量" prop="smsQuantity">
        <a-input
          v-model="form.smsQuantity"
          oninput="value=value.replace(/[^\d]/g,'')"
          placeholder="请输入"
          :maxLength="20"
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <!-- <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item> -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/sms'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
    userList: {
      type: Array,
      required: false,
    },
    id: {
      type: [Number, String],
      required: false,
    },
  },
  components: {},
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        money: undefined,
        remark: undefined,
        smsQuantity: undefined,
        tenantId: undefined,
      },
      isShow: false,
      tags: [],
      tagslist: [],
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      rules: {
        tenantId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
        smsQuantity: [{ required: true, message: '请输入区域短信数量', trigger: 'blur' }],
        money: [{ required: true, message: '请输入费用金额', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
      this.open = false
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },
    showInputs() {
      this.inputVisibles = true
      this.$nextTick(function () {
        this.$refs.inputs.focus()
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 选择省
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        money: undefined,
        remark: undefined,
        smsQuantity: undefined,
        upperId: undefined,
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd(e) {
      this.reset()
      this.open = true
      this.formTitle = '短信充值'
      this.form.tenantId = e
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids

      getObj(postId).then((response) => {
        console.log(response.data, 'response.data')
        this.form = response.data
        this.open = true
        this.formTitle = '修改设备'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
                this.$emit('changeBack')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
